/** This tab's identity to the robot: one id per tab, so two tabs are two operators. */

const KEY = "operator.id";

let cached: string | null = null;

export function operatorId(): string {
  if (cached) return cached;
  try {
    const stored = sessionStorage.getItem(KEY);
    if (stored) return (cached = stored);
  } catch {
    // private windows and blocked site data: a per-load id is still a valid identity
  }
  cached = crypto.randomUUID();
  try {
    sessionStorage.setItem(KEY, cached);
  } catch {
    // nothing to do: the id lives for this page load only
  }
  return cached;
}
